@if (toasty) {
  <div class="py-2 px-4 rounded-[24px] flex flex-row gap-4 min-w-[300px] max-w-[610px] w-full toasty items-center"
    [ngClass]="classes">
    <div class="flex-shrink-0 flex items-center">
      <i-tabler [name]="icon"></i-tabler>
    </div>
    <div class="text-white-80 text-[14px]">
      {{ toasty.message }}
    </div>
  </div>
}